<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.81657 5.52933C4.7749 5.52516 4.7249 5.52516 4.67907 5.52933C3.6874 5.496 2.8999 4.6835 2.8999 3.6835C2.8999 2.66266 3.7249 1.8335 4.7499 1.8335C5.77074 1.8335 6.5999 2.66266 6.5999 3.6835C6.59574 4.6835 5.80824 5.496 4.81657 5.52933Z"
      :stroke="color"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.83737 2.6665C8.6457 2.6665 9.2957 3.32067 9.2957 4.12484C9.2957 4.91234 8.6707 5.554 7.89154 5.58317C7.8582 5.579 7.8207 5.579 7.7832 5.58317"
      :stroke="color"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.7333 7.0665C1.72497 7.7415 1.72497 8.8415 2.7333 9.51234C3.87913 10.279 5.7583 10.279 6.90413 9.51234C7.91247 8.83734 7.91247 7.73734 6.90413 7.0665C5.76247 6.304 3.8833 6.304 2.7333 7.0665Z"
      :stroke="color"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.6416 9.3335C8.9416 9.271 9.22493 9.15016 9.45827 8.971C10.1083 8.4835 10.1083 7.67933 9.45827 7.19183C9.2291 7.01683 8.94994 6.90016 8.6541 6.8335"
      :stroke="color"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconParticipants',
  props: {
    size: {
      type: [Number, String],
      default: 12
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>
